import { render, staticRenderFns } from "./DiscussTopicItem.vue?vue&type=template&id=633b1ad1&scoped=true&"
import script from "./DiscussTopicItem.vue?vue&type=script&lang=ts&"
export * from "./DiscussTopicItem.vue?vue&type=script&lang=ts&"
import style0 from "./DiscussTopicItem.vue?vue&type=style&index=0&id=633b1ad1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b1ad1",
  null
  
)

export default component.exports